<template>
  <div id="product">
    <header-el></header-el>
    <div class="mb20">
      <div class="search-container" style="width: 100%; height: 300px;">
        <div class="search-mask"></div>
        <img style="height: 300px;object-fit:contain;"  src="/images/shop.jpg" />
        <div class="search-list">
          <div class="search-part">
            <input type="text" placeholder="搜索商品……" autofocus="autofocus" class="search-input"
              v-model="d_searchval"

              v-on:input="searchkeydown"
              v-on:keyup="deletesearchval"
              />
            <input type="submit" value="搜  索" class="search-btn" v-on:click="loadProduct()" />
          </div>
          <div class="hot-word">
            <span>热词搜索：</span>
            <!--<a href="javascript:;" v-on:click="filter.Title=null;loadProduct()">全部</a>-->
            <a href="javascript:;" v-on:click="searchbtnclick('PUMA')">PUMA</a>
            <a href="javascript:;" v-on:click="searchbtnclick('Nike')">Nike</a>
            <a href="javascript:;" v-on:click="searchbtnclick('New Balance')">New Balance</a>
          </div>
        </div>
      </div>
    </div>
    <div class="project-screen" v-if="d_productScreenshow">
      <div class="screen-head">
        <ul class="screen-title">
          <li :class="globalConfig.selectedCategoryID==category.ID?'screen-active':''" v-for="category in categories" v-on:click="caregorchoose(category.ID)" v-bind:key="category.ID">{{category.Name}}</li>
        </ul>
        <div class="screen-button" style="display:none;">
          <div class="special-button">
            <div class style="width: 130px;">
              <div class="select-tab" :class="{'select-tab-click':globalConfig.statusIsShow}" v-on:click="selecttab1">
                <span>{{globalConfig.statusText}}</span>
                <span class="status-icon" :class="{'icon-kaistart-direction-up':globalConfig.statusIsShow,'icon-kaistart-direction-down':!globalConfig.statusIsShow}"></span>
              </div>
              <div class="option-tab" style="width: 130px; " v-show="globalConfig.statusIsShow">
                <ul>
                  <li :class="{'active':globalConfig.statusText=='待发布'}" v-on:click="sortselect1('待发布')">待发布</li>
                  <li :class="{'active':globalConfig.statusText=='进行中'}" v-on:click="sortselect1('进行中')">进行中</li>
                  <li :class="{'active':globalConfig.statusText=='已结束'}" v-on:click="sortselect1('已结束')">已结束</li>
                </ul>
              </div>
              <div data-v-042cdcc3="" :class="{'special-cover':globalConfig.sortText=='即将结束'}"></div>
            </div>
            <div class></div>
          </div>
          <div class="special-button">
            <div style="width: 130px;">
              <div class="select-tab" @click="selecttab2" :class="{'select-tab-click':globalConfig.sortIsShow}">
                <span>{{globalConfig.sortText}}</span>
                <span class="status-icon" :class="{'icon-kaistart-direction-up':globalConfig.sortIsShow,'icon-kaistart-direction-down':!globalConfig.sortIsShow}"></span>
              </div>
              <div class="option-tab" style="width: 130px;" v-show="globalConfig.sortIsShow">
                <ul>
                  <li :class="{'active':globalConfig.sortText=='最新上线'}" v-on:click="sortselect2('最新上线')">最新上线</li>
                  <li :class="{'active':globalConfig.sortText=='即将结束'}" v-on:click="sortselect2('即将结束')">即将结束</li>
                </ul>
              </div>
              <div data-v-042cdcc3="" :class="{'special-cover':globalConfig.statusText=='已结束'}"></div>
            </div>
            <div></div>
          </div>
        </div>
      </div>
      <ul class="screen-list moreli">
        <productLoading-el v-bind:loadingstart="d_loadingstart" v-bind:loadingempty="d_loadingempty"></productLoading-el>
        <productBox-el v-for="product in products.Results" v-bind:key="product.ID" v-bind:product="product"></productBox-el>
      </ul>
      <!-- <div class="screen-more">
        <div>
          <div class="spinner">
            <div class="spinner-container container1">
              <div class="circle1"></div>
              <div class="circle2"></div>
              <div class="circle3"></div>
              <div class="circle4"></div>
            </div>
            <div class="spinner-container container2">
              <div class="circle1"></div>
              <div class="circle2"></div>
              <div class="circle3"></div>
              <div class="circle4"></div>
            </div>
            <div class="spinner-container container3">
              <div class="circle1"></div>
              <div class="circle2"></div>
              <div class="circle3"></div>
              <div class="circle4"></div>
            </div>
          </div>
        </div>
        <span style="display: none;">没有更多数据了...</span>
      </div> -->
    </div>
    <div class="result-contaniner" v-if="!d_productScreenshow">
      <div class="result-title">
        <span>搜索结果</span>包含关键词
        <b v-text="d_searproductchval"></b> 的结果
        <b v-text="products.TotalCount"></b> 个
      </div>
      <div class="result-subtitle">
        <span class="result-subtitle-btn">商品</span>
      </div>
      <ul class="result-program">
        <productBox-el v-for="product in products.Results" v-bind:key="product.ID" v-bind:product="product"></productBox-el>
      </ul>
      <div class="nomore" v-show="products.TotalCount==0">
        <p>没有更多商品了...</p>
      </div>
      <div class="page-nav clear" v-show="pageData.length>1">

      <ul>
        <li v-show="products.PageNumber>1"><a @click="pageclickitem(products.PageNumber-1)"><i class="icon-kaistart icon-kaistart-direction-left"></i></a></li>
              <li class="cursor"
                    v-for="(item,index) in pageData"
                    v-bind:key="index"
                    v-bind:class="{ active: products.PageNumber == item,empty:item === '...' }">
                    <a href="javascript:;" style="color:#61616f;" v-if="item === '...'">...</a>
                    <a v-else @click="pageclickitem(item)">{{item}}</a>
              </li>
        <li v-show="products.PageNumber!=products.PageCount"><a @click="pageclickitem(products.PageNumber+1)"><i class="icon-kaistart icon-kaistart-direction-right" ></i></a></li>
      </ul>

      </div>

      <!---->
      <div class="result-nav">
        <!---->
      </div>
    </div>
    <navshare-el/>
    <footer-el></footer-el>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import Header from "../components/header";
import Footer from "../components/footer";
import productBox from "../components/productBox";
import productLoading from "../components/productLoading";
import NavShare from "../components/navShare";
export default {
  name: "product",
  components: {
    "header-el": Header,
    "footer-el": Footer,
    "productBox-el": productBox,
    "productLoading-el":productLoading,
    "navshare-el":NavShare
  },
  computed: {
    // ...mapGetters(['home/productsQTY']),
    ...mapState({
      products: state => state.product.products,
      categories: state => state.product.categories
      // advertisements: state => state.product.advertisements
    }),
    // products:{
    //   get (){
    //     return this.$store.state.product.products
    //   },
    //   set (val) {}
    // },
  pageData:function() {
            var i,
            t = this,
            len = 7,
            arr = [1, 2, 3, 4, 5, 6, 7],
            finalArr = [],
            start,
            end,
            //t.products.PageCount
            pageCount = t.products.PageCount,
            //pageCount = 10,
            //t.products.PageNumber
            pageNumber = t.products.PageNumber;

            len =  pageCount < len ? pageCount : len;
            for (i = 0; i < len; i++) {
                finalArr[i] = (i+1);
            }
            if(len < 7){
                return finalArr;
            }
            if(pageNumber < 5){
                finalArr[len - 2] = '...';
                finalArr[len - 1] = pageCount;
            }else{
                if(pageNumber >= pageCount - 3){
                    start = pageCount - 4;
                    end = pageCount;
                    finalArr = [1,'...']
                    for(start; start <= end; start++){
                        finalArr.push(start);
                    }
                }else{
                    start = 3 + (pageNumber - 5);
                    end = 7 + (pageNumber - 5);
                    finalArr = [1,'...']
                    for(start; start <= end; start++){
                        finalArr.push(start);
                    }
                    finalArr.push('...');
                    finalArr.push(pageCount);
                }

            }
            return finalArr;
        }
  },
  data() {
    return {
      globalConfig: {
        statusIsShow: false,
        statusText:'产品状态',
        sortIsShow: false,
        sortText:'排序',
        selectedCategoryID:1
      },
      filter:{
        Title: { Value: null },
        Pager: { PageNumber: 1, PageSize: 20 },
        CreateTime: { Sort: 1 },
        SaleCategoryIDs: { Value: ',1,'}
      },
      d_loadingstart:false,
      d_loadingempty:false,
      d_searchval:"",
      flag:false,
      d_productScreenshow:true,
      d_searproductchval:''

    };
  },
  methods: {
    caregorchoose:function(vals) {
      var t = this
      t.filter.SaleCategoryIDs={Value:','+vals+','};
      t.filter.Pager.PageNumber=1
      t.$store.dispatch("product/setproducts", '{}');
      t.loadProduct();
      t.globalConfig.selectedCategoryID=vals;

    },
    //分页点击
    pageclickitem:function(num) {
      var t  = this
      t.filter.Pager={
        PageNumber: num,
        PageSize: 20
      }
      t.loadProduct()
    },

    //触焦输入框
    searchkeydown:function(e) {
       var t = this

      if(!e.target.composing) {
        t.filter.Title={'Value':t.d_searchval};
        t.filter.Pager= { PageNumber: 1, PageSize: 20 }
        t.filter.SaleCategoryIDs={'Value':null}
        t.loadProduct()
      }
      t.d_searproductchval = t.d_searchval
    },
    //输入框删除
    deletesearchval:function(e) {

       var t = this
       if(t.d_searchval==""){
         return;
       }
       t.filter.Title={'Value':t.d_searchval};
       t.filter.SaleCategoryIDs={'Value':null}
      if(e.keyCode==13 || e.key =='Enter') {
        t.loadProduct()
      }
       // return "button" in e || !t._k(e.keyCode, "enter", 13, e.key, "Enter") ? t.getSearchResult(e) : null

       t.d_searproductchval = t.d_searchval

    },
    searchbtnclick:function(val) {
      var t = this
      t.d_productScreenshow = false
       t.filter.SaleCategoryIDs={'Value':null}
      t.filter.Title={'Value':val};
      t.loadProduct()
      t.d_searproductchval = val
    },

    selecttab1:function(e) {
      e.stopPropagation();
      this.globalConfig.statusIsShow=!this.globalConfig.statusIsShow
      this.globalConfig.sortIsShow = false
    },
    selecttab2:function(e) {
      e.stopPropagation();
      this.globalConfig.sortIsShow=!this.globalConfig.sortIsShow
      this.globalConfig.statusIsShow = false
    },
    sortselect1:function(val) {
      this.filter.Status={Value:1};
      this.loadProduct();
      this.globalConfig.statusIsShow=!this.globalConfig.statusIsShow;
      this.globalConfig.statusText=val

    },
    sortselect2:function(val) {
      this.filter.CreateTime={Sort:1};
      this.loadProduct();
      this.globalConfig.sortIsShow=!this.globalConfig.sortIsShow;
      this.globalConfig.sortText=val

    },
    loadProduct: function() {

      this.d_loadingstart = true

      this.$store.dispatch("product/getProducts", this.filter);

    },
    scrollloadproject:function() {
      var t = this
      if(!this.d_productScreenshow) {
        return false;
      }
       if (
        document.documentElement.scrollTop +
          document.documentElement.clientHeight >=
        document.body.scrollHeight-100
      ) {

         if(this.filter.Pager.PageNumber>this.products.PageCount) {
          return false;
        }

         this.filter.Pager.PageNumber += 1;
         this.loadProduct();

      }
    },
  },
  watch: {
    products(val) {
      this.d_loadingstart = false
       if(val.Results && val.Results.length==0) {
        this.d_loadingempty = true
      }else {
        this.d_loadingempty = false
      }

    },
    d_searchval(val) {
      var t = this
      if(val=="") {
         t.d_productScreenshow = true
         t.filter={
            Title: { Value: null },
            Pager: { PageNumber: 1, PageSize: 20 },
            CreateTime: { Sort: 1 },
            SaleCategoryIDs: { Value: t. globalConfig.selectedCategoryID}
          }

         t.loadProduct();
      }else {
         t.d_productScreenshow = false
      }
    }
  },
  created: function() {
    var t = this
    this.$store.dispatch("product/getAllCategory").then((cid)=>{
      //alert(this.filter.Pager.PageNumber)
      t.filter={
            Title: { Value: null },
            Pager: { PageNumber: 1, PageSize: 20 },
            CreateTime: { Sort: 1 },
            SaleCategoryIDs: { Value: ','+cid+','}
      }
      this.$store.dispatch("product/getProducts", this.filter);

    });
  },
  mounted: function() {
    var t = this
    document.addEventListener("click",function(){
        if(document.getElementsByClassName("option-tab").length==0) return;
          document.getElementsByClassName("option-tab")[0].style.display="none";
          document.getElementsByClassName("option-tab")[1].style.display="none";
          t.globalConfig.statusIsShow = false
          t.globalConfig.sortIsShow = false
    },false);

    this.loadProduct();
    window.addEventListener("scroll", this.scrollloadproject);
  },
};
</script>
<style>
@import url("../css/projectlist.css");
.screen-list{
  padding-bottom:20px;
}
footer{
  padding: 80px 0 0px;
}
</style>
